import { forwardRef, ForwardedRef, ReactNode } from "react";
import FaiTypographyRoot from "./FaiTypographyRoot";

// MUI context
import { useFaiController } from "../../context";
import FaiBox from "../FaiBox";
import { Tooltip } from "@mui/material";
import ErrorRounded from "@mui/icons-material/ErrorRounded";

interface FaiTypographyProps {
	color?:
		| "inherit"
		| "primary"
		| "secondary"
		| "info"
		| "success"
		| "warning"
		| "error"
		| "light"
		| "dark"
		| "text"
		| "white";
	fontWeight?: "light" | "regular" | "medium" | "bold";
	textTransform?: "none" | "capitalize" | "uppercase" | "lowercase";
	verticalAlign?:
		| "unset"
		| "baseline"
		| "sub"
		| "super"
		| "text-top"
		| "text-bottom"
		| "middle"
		| "top"
		| "bottom";
	textGradient?: boolean;
	children: ReactNode;
	opacity?: number;
	isRequired?: boolean;
	note?: string;

	[key: string]: any;
}

const FaiTypography = forwardRef(
	(props: FaiTypographyProps, ref: ForwardedRef<any>) => {
		const {
			color = "dark",
			fontWeight = "regular",
			textTransform = "none",
			verticalAlign = "unset",
			textGradient = false,
			opacity = 1,
			children,
			isRequired = false,
			note = "",
			className = "",
			...rest
		} = props;

		const [controller] = useFaiController();
		const { darkMode } = controller;

		return (
			<FaiBox className={`flex ${note ? "justify-between" : ""}`}>
				<FaiTypographyRoot
					{...rest}
					ref={ref}
					ownerState={{
						color,
						textTransform,
						verticalAlign,
						fontWeight,
						opacity,
						textGradient,
						darkMode,
					}}
					className={className}
				>
					{children}
					{isRequired && <span className="text-red-600">*</span>}
				</FaiTypographyRoot>
				{note && (
					<Tooltip title={note}>
						<ErrorRounded color="disabled" />
					</Tooltip>
				)}
			</FaiBox>
		);
	}
);

export default FaiTypography;
